module.exports = __webpack_public_path__ + "play_mini_ac.8f6e2295.png";